module.exports = __webpack_public_path__ + "media/media/values/face-2-c31b732bbb916afaf6b8300939d5a930.jpg";